import COS from "cos-js-sdk-v5";
import {Notify, Toast} from 'vant';
import {EventBus} from "@/main";
import exifr from 'exifr'
import {AREA_CODE, EventBusKey, FILTER_TYPE} from "@/constant/Constants";
import {isRegExp} from "qs/lib/utils";
const cos = new COS({
    SecretId: 'AKIDOdfSSHrBG6h27wWv75pT1NT4VjhPr30i',
    SecretKey: 'Wmoa8au0rVxBAzd9WnxyoSvPl6LSO6ap'
});
const bucket = 'gb-1312119544';
const region = 'ap-guangzhou';
const defaultSuffix = '\n—————————————————————————————————————' +
    '\n网站链接：https://guide-book.lijun.space';
const isWechat = /MicroMessenger/i.test(navigator.userAgent)
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
export default {
    joinObject(obj, separator = ', ', keyValueSeparator = undefined) {
        return Object.entries(obj)
            .map(([key, value]) => `${keyValueSeparator?`${key}${keyValueSeparator}`:''}${value}`)
            .join(separator);
    },
    getFileIcon(key,mime) {
        let mimeType = ["mp3","fb2","wav","avi",
            "java","xls","js","txt",
            "rar","eps","ai","gif",
            "cdr","psd","flv","raw",
            "html","epub","msi",
            "zip","pdf","doc","jpg",
            "ae","png","tiff","ppt",
            "com","mp4","svg","ttf","apk"]
        var findLastIndex = key.lastIndexOf(".");
        if (findLastIndex <= -1) {
            console.log("未找到Index")
            return "other-file";
        }else{
            let fileSuffix = key.substring(findLastIndex+1);
            console.log("后缀：",fileSuffix)
            let s = mimeType.findIndex(filetype => filetype === fileSuffix);
            if (s <= -1) {
                console.log("未找到FileType");
                return "other-file";
            }else{
                console.log("返回"+mimeType[s])
                return mimeType[s];
            }

        }



    },
    /**
     * 测试的数据
     * @param keys
     * @returns {Promise<unknown>}
     */
    deleteFiles(keys) {
        if (typeof keys === 'string') {
            Notify({message:'值错误！',type:'danger', duration: 3000});
            return;
        }
        if (keys.length <= 0) {
            Notify({message:'值错误！',type:'danger', duration: 3000});
            return;
        }
        let obj = [];
        keys.forEach(item =>{
            obj.push({Key: item});
        })
        return new Promise((resolve, reject) =>{
            cos.deleteMultipleObject({
                Bucket: bucket, // 填入您自己的存储桶，必须字段
                Region: region,  // 存储桶所在地域，例如ap-beijing，必须字段
                Objects: obj
            }).then(res =>{
                resolve(res);
            }).catch(cat =>{
                reject(cat)
            })
        })
    },
    deleteFile(key) {
        return new Promise((resolve, reject) => {
            cos.deleteObject({
                Bucket: bucket, // 填入您自己的存储桶，必须字段
                Region: region,  // 存储桶所在地域，例如ap-beijing，必须字
                Key: key,  // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
            }).then(res =>{
                resolve(res);
            }).catch(cat =>{
                reject(cat);
            })
        })
    },
    formatBytes(bytes) {
        if (typeof bytes !== 'number' || bytes < 0) return '0 B';

        const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let unitIndex = 0;
        let num = bytes;

        // 找到合适的单位
        while (num >= 1024 && unitIndex < units.length - 1) {
            num /= 1024;
            unitIndex++;
        }

        // 智能格式化数值
        const formatted = num % 1 === 0
            ? num.toString()               // 整数直接转字符串
            : num.toFixed(2).replace(/\.?0+$/, ''); // 小数保留两位并去除末尾零

        return `${formatted} ${units[unitIndex]}`;
    },
    /**
     * 创建BLOB格式的图片数据URL
     * @param blob 数据
     * @returns {string} 数据生成的URL
     */
    createBlobUrl(blob) {
        const url = URL.createObjectURL(blob);
        return url;
    },
    /**
     * 将blob数据转换为file对象
     * @param blob 数据
     * @param fileName 文件名
     * @param options 参数
     * @returns {module:buffer.File} 文件对象
     */
    blobToFile(blob, fileName, options = {}) {
        // 设置默认文件属性
        const fileOptions = {
            type: blob.type || 'application/octet-stream',
            ...options
        };

        // 创建File对象（File是Blob的子类）
        return new File([blob], fileName, fileOptions);
    },
    /**
     * 获取文件名称
     * @param location 文件路径
     * @returns {string|*} 文件名称
     */
    getFileName(location) {
        var s = decodeURI(location);
        console.log('decodeURI => ',s);
        const firstSlashIndex = location.indexOf("/"); // 查找第一个斜杠的位置
        const result = firstSlashIndex !== -1 ? location.substring(firstSlashIndex+1) : location;
        return result
    },
    getMapImg(fileName) {
        return this.getFileUrl('pic/laojunshan/' + fileName);
    },
    /**
     *
     * @param fileObject 传输的文件对象
     * @param path 文件在 COS 服务端的路径
     *
     * @returns object{code,message,data,data.access_url,data.source_url,data.url,data.resource_path}
     * @returnParams
     * code: 错误码，成功时为0
     * message: 提示信息
     * data: 返回数据
     *      data.access_url: 生成的文件 CDN 下载 url
     *      data.source_url: 生成的文件 COS 源站 url
     *      data.url: 操作文件的 url
     *      data.resource_path: 资源路径，格式：/appid/bucket/xxx
     */
    uploadFile(fileObject,path='sysImg/') {
        if (path!==undefined&&path !== null && path.trim().length>0) {
            path = path.trim();
            if (!path.endsWith("/")) {
                path += "/";
            }
        } else {
            path = ""; // 空目录视为根目录
        }
        return new Promise((resolve, reject) =>{
            console.log('要上传的文件：', fileObject);
            cos.uploadFile({
                Bucket: bucket, // 填入您自己的存储桶，必须字段
                Region: region,  // 存储桶所在地域，例如 ap-beijing，必须字段
                Key: path+fileObject.name,  // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
                Body: fileObject, // 必须，上传文件对象，可以是 input[type="file"]标签选择本地文件后得到的 file 对象
                SliceSize: 1024 * 1024 * 20,     // 触发分块上传的阈值，超过5MB使用分块上传，默认 1MB，非必须
                ChunkSize: 1024 * 1024, // 分块大小，默认 1MB，非必须
                onTaskReady: function(taskId) {  // 非必须
                    console.log(taskId);
                },
                onProgress: function (progressData) { // 非必须
                    console.log('当前进度：',JSON.stringify(progressData));
                    EventBus.$emit(EventBusKey.circleProgress,progressData.loaded!==progressData.total,
                        progressData.total,
                        progressData.loaded,
                        progressData.speed)
                },
                // 支持自定义 headers 非必须
                Headers: {
                    'x-cos-meta-test': 123
                },
            }).then(data =>{
                Notify({message:`上传文件成功!`,type:'success',duration:3000})
                resolve(data);
            }).catch(err =>{
                Notify({message:`上传文件失败，原因：${err.message}`,type:'danger',duration:3000})
                reject(err)
            });
        })

    },
    getFileObject(key) {
        console.log("getFileObject ==>", key);
        return new Promise((resolve, reject) =>{
            cos.getObject({
                Bucket: bucket,
                Region: region,
                Key: key,
                Sign: false,
                DataType: 'blob',
            }).then(res => {
                console.log("getFileObject data", res);
                const fileType = res.headers['content-type'];
                resolve({key: key, obj: fileType, data: res})
            }).catch(err => {
                console.error("getFileObject err", err);
                reject(err);
            });
        })
    },
    /**
     * ETag "\"b2d302cc7300930c711cc8f853235bd5\""
     * RequestId "NjdkMDYyNmVfOGIyYzJjMGJfODFhZl8xYjRhNTVjMA=="
     * headers
     * content-length "4524333"
     * content-type "image/jpeg"
     * etag "\"b2d302cc7300930c711cc8f853235bd5\""
     * last-modified "Sun, 23 Feb 2025 18:09:36 GMT"
     * x-cos-request-id "NjdkMDYyNmVfOGIyYzJjMGJfODFhZl8xYjRhNTVjMA=="
     * statusCode 200
     */
    getFileHeader(key) {
        console.log("getFileHeader 获取的Key",key)
        return new Promise((resolve, reject) =>{
            cos.headObject({
                Bucket: bucket, // 填入您自己的存储桶，必须字段
                Region: region,  // 存储桶所在地域，例如ap-beijing，必须字段
                Key: key,  // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
            }).then(res =>{
                resolve(res);
            }).catch(err =>{
                reject(err);
            });
        })
    },
    createDir(key) {
        return cos.putObject({
            Bucket: bucket, // 填入您自己的存储桶，必须字段
            Region: region,  // 存储桶所在地域，例如 ap-beijing，必须字段
            Key: key,  // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
            Body: '',
        })
    },
    getFileUrl(key) {
        console.log("key =>", key);
        return {key:key,url:cos.getObjectUrl({
                Bucket: bucket,
                Region: region,
                Key: key,
                Sign: false,
            })}
    },
    listFiles(prefix,delimiter='/') {
        let fileList = [];
        let dirList = [];
        return new Promise((resolve, reject) =>{
            cos.getBucket({
                Bucket: bucket,
                Region: region,
                Prefix: prefix,
                Delimiter: delimiter,

            }, (err, data) => {
                console.log(err, data);
                if (err) {
                    console.error(err)
                    reject(err);
                } else {
                    console.log("获取的文件目录 ===》 ",data)
                    for (let i = 1; i < data.Contents.length; i++) {//因为content中的第一个是当前文件的目录，所以下标从1开始获取
                       // console.log('INDEX：=》', data.Contents[i]);
                        //let s = this.getFileUrl(data.Contents[i].Key);
                        //console.log("RETURN => ", s);
                        fileList.push(data.Contents[i].Key)
                    }
                    for (let i = 0; i < data.CommonPrefixes.length; i++) {
                        dirList.push(data.CommonPrefixes[i].Prefix);
                    }
                    resolve({files:fileList,dirs:dirList, prefix: data.Prefix})
                }
            })
        })

    },
    decodeExif(url) {
        const mapping={
            "ApertureValue":{name:"光圈值",func:(value,data) =>value},
            "BitsPerSample":{name:"位深度",func:(value,data) =>value},
            "BlueMatrixColumn":{name:"蓝色矩阵柱",func:(value,data) =>value},
            "BlueTRC":{name:"",func:(value,data) =>value},
            "BrightnessValue":{name:"",func:(value,data) =>value},
            "ColorSpace":{name:"",func:(value,data) =>value},
            "ColorSpaceData":{name:"",func:(value,data) =>value},
            "ComponentsConfiguration":{name:"",func:(value,data) =>value},
            "CompressedBitsPerPixel":{name:"",func:(value,data) =>value},
            "Contrast":{name:"",func:(value,data) =>value},
            "CreateDate":{name:"",func:(value,data) =>value},
            "CustomRendered":{name:"",func:(value,data) =>value},
            "DateTimeOriginal":{name:"",func:(value,data) =>value},
            "DeviceManufacturer":{name:"",func:(value,data) =>value},
            "DeviceModel":{name:"",func:(value,data) =>value},
            "DigitalZoomRatio":{name:"",func:(value,data) =>value},
            "ExifImageHeight":{name:"",func:(value,data) =>value},
            "ExifImageWidth":{name:"",func:(value,data) =>value},
            "ExifVersion":{name:"",func:(value,data) =>value},
            "ExposureCompensation":{name:"",func:(value,data) =>value},
            "ExposureMode":{name:"",func:(value,data) =>value},
            "ExposureProgram":{name:"",func:(value,data) =>value},
            "ExposureTime":{name:"",func:(value,data) =>value},
            "FNumber":{name:"",func:(value,data) =>value},
            "FileSource":{name:"",func:(value,data) =>value},
            "Flash":{name:"",func:(value,data) =>value},
            "FlashpixVersion":{name:"",func:(value,data) =>value},
            "FocalLength":{name:"",func:(value,data) =>value},
            "FocalLengthIn35mmFormat":{name:"",func:(value,data) =>value},
            "GPSAltitude":{name:"",func:(value,data) =>value},
            "GPSAltitudeRef":{name:"",func:(value,data) =>value},
            "GPSDateStamp":{name:"",func:(value,data) =>value},
            "GPSLatitude":{name:"",func:(value,data) =>value},
            "GPSLatitudeRef":{name:"",func:(value,data) =>value},
            "GPSLongitude":{name:"",func:(value,data) =>value},
            "GPSLongitudeRef":{name:"",func:(value,data) =>value},
            "GPSProcessingMethod":{name:"",func:(value,data) =>value},
            "GPSTimeStamp":{name:"",func:(value,data) =>value},
            "GPSVersionID":{name:"",func:(value,data) =>value},
            "GainControl":{name:"",func:(value,data) =>value},
            "GreenMatrixColumn":{name:"",func:(value,data) =>value},
            "GreenTRC":{name:"",func:(value,data) =>value},
            "ISO":{name:"",func:(value,data) =>value},
            "ImageDescription":{name:"",func:(value,data) =>value},
            "ImageHeight":{name:"",func:(value,data) =>value},
            "ImageWidth":{name:"",func:(value,data) =>value},
            "InteropIndex":{name:"",func:(value,data) =>value},
            "JFIFVersion":{name:"",func:(value,data) =>value},
            "LightSource":{name:"",func:(value,data) =>value},
            "Make":{name:"",func:(value,data) =>value},
            "MaxApertureValue":{name:"",func:(value,data) =>value},
            "MediaWhitePoint":{name:"",func:(value,data) =>value},
            "MeteringMode":{name:"",func:(value,data) =>value},
            "Model":{name:"",func:(value,data) =>value},
            "ModifyDate":{name:"",func:(value,data) =>value},
            "Orientation":{name:"",func:(value,data) =>value},
            "PrimaryPlatform":{name:"",func:(value,data) =>value},
            "ProfileCMMType":{name:"",func:(value,data) =>value},
            "ProfileClass":{name:"",func:(value,data) =>value},
            "ProfileConnectionSpace":{name:"",func:(value,data) =>value},
            "ProfileCopyright":{name:"",func:(value,data) =>value},
            "ProfileCreator":{name:"",func:(value,data) =>value},
            "ProfileDateTime":{name:"",func:(value,data) =>value},
            "ProfileDescription":{name:"",func:(value,data) =>value},
            "ProfileFileSignature":{name:"",func:(value,data) =>value},
            "ProfileVersion":{name:"",func:(value,data) =>value},
            "RedMatrixColumn":{name:"",func:(value,data) =>value},
            "RedTRC":{name:"",func:(value,data) =>value},
            "RenderingIntent":{name:"",func:(value,data) =>value},
            "ResolutionUnit":{name:"",func:(value,data) =>value},
            "Saturation":{name:"",func:(value,data) =>value},
            "SceneCaptureType":{name:"",func:(value,data) =>value},
            "SceneType":{name:"",func:(value,data) =>value},
            "SensingMethod":{name:"",func:(value,data) =>value},
            "Sharpness":{name:"",func:(value,data) =>value},
            "ShutterSpeedValue":{name:"",func:(value,data) =>value},
            "Software":{name:"",func:(value,data) =>value},
            "SubSecTime":{name:"",func:(value,data) =>value},
            "SubSecTimeDigitized":{name:"",func:(value,data) =>value},
            "SubSecTimeOriginal":{name:"",func:(value,data) =>value},
            "SubjectDistanceRange":{name:"",func:(value,data) =>value},
            "ThumbnailHeight":{name:"",func:(value,data) =>value},
            "ThumbnailWidth":{name:"",func:(value,data) =>value},
            "WhiteBalance":{name:"",func:(value,data) =>value},
            "XResolution":{name:"",func:(value,data) =>value},
            "YCbCrPositioning":{name:"",func:(value,data) =>value},
            "YResolution":{name:"",func:(value,data) =>value},
            "latitude":{name:"",func:(value,data) =>value},
            "longitude":{name:"",func:(value,data) =>value},
            "makerNote":{name:"",func:(value,data) =>value},
        }
        const result = [];
        let urls = this.getFileUrl(url).url;
        return exifr.parse(urls, true).then(out =>{
            console.log('out', out);
            for (const outKey in out) {
                result.push({name:outKey, value: out[outKey]})
            }
            return result;

        }).catch(cat =>{
            console.log('cat',cat)
            throw cat; // 传递错误
        });
        // exifr.parse(urls).then(out =>{
        //     console.log('out2', out);
        // }).catch(cat =>{
        //     console.log('cat2',cat)
        // });
        // exifr.gps(urls).then(out =>{
        //     console.log('gps', out);
        // }).catch(cat =>{
        //     console.log('gps',cat)
        // });
    },

    /**
     * 根据元素ID复制文本
     * @param id 要复制的文本的元素的ID
     */
    writeTextByElementId(id) {
        let textContent = document.getElementById(id).textContent
        this.copyText(textContent)
    },
    /**
     * navigator.clipboard.writeText(text) 是 Web API Navigator Clipboard 接口提供的方法，用于将指定文本写入到用户剪贴板中。
     * 如果用户授予了访问剪贴板的权限且剪贴板为空，则该文本被写入到剪贴板中，此时该方法返回 Promise 对象并处于 resolved 状态；
     * 如果用户未授予权限、剪贴板非空或者发生其它错误，则 Promise 对象处于 rejected 状态，可以通过 catch 方法获取错误信息。
     * 将文本内容写入到剪贴板
     * @param text 要写入到剪贴板的文本
     * @param headers 消息提示的头
     * @param prefix 文本前缀
     * @param addSuffix 是否添加后缀
     * @param suffix 文本后缀
     */
    copyText(text, headers = '文本', prefix = '', addSuffix = false, suffix = defaultSuffix) {
        if (addSuffix) {
            text += suffix
        }
        text = prefix + text;
        try {
            if (navigator.clipboard) {
                navigator.permissions.query({name:'clipboard-write'}).then(res =>{
                    if (res.state === 'granted' || res.state === 'prompt') {
                        try {
                            navigator.clipboard.writeText(text).then(() => {
                                Toast({message:`${headers} 复制成功！`,duration:3000,position:'bottom'})
                                console.log('content:' + text)
                            })
                        }catch (e) {
                            this.AbandonedCopyText(headers, text);
                        }
                    }else{
                        Notify({type:'danger',message:`不允许访问剪贴板`,duration:3000})
                        console.log(res)
                    }
                })
            }else{
                throw new Error('不兼容现代浏览器API');
            }
        }catch (e) {
            this.AbandonedCopyText(headers, text);
        }
    },

    /**
     * 使用降级方法复制文本
     * @param headers 复制文本成功时提示框头部的文字
     * @param text 复制的文本
     */
    //Abandoned copy
    AbandonedCopyText(headers, text) {
        let inputObj = document.createElement("input");
        inputObj.value = text;
        document.body.appendChild(inputObj);
        inputObj.select();
        inputObj.setSelectionRange(0, inputObj.value.length);
        var command = document.execCommand('Copy');
        if (command) {
            Toast({message:`${headers} 降级复制成功！`,duration:3000,position:'bottom'})
        }else{
            Notify({type:'danger', message: `降级方法复制文本失败！`,duration:3000})
        }
        document.body.removeChild(inputObj);
    },


    /**
     * 获取图片的宽高
     * @param file 文件对象
     * @returns {Promise<unknown>} 异步返回数据
     */
    getImageWH(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = e => {
                const image = new Image()
                image.onload = () => {
                    resolve({
                        width: image.width,
                        height: image.height
                    })
                }
                image.src = e.target.result
            }
            reader.readAsDataURL(file)
        })
    },
    /**
     * 格式化数据
     * @param value 数据内容
     * @param filterType 需要格式化的选项
     * @returns {string} 格式化后的数据
     */
    formatData(value, ...filterType) {
        let val = value
        for (let i = 0; i < filterType.length; i++) {

            const filter = filterType[i];

            // 处理函数型过滤器（REGEX/LENGTH）
            if (typeof filter === 'function') {
                val = filter(val);
            }

            // 处理普通过滤器
            switch (filter) {
                case FILTER_TYPE.TO_UPPER_CASE:
                    val = val.toUpperCase();
                    break;

                case FILTER_TYPE.TO_LOWER_CASE:
                    val = val.toLowerCase();
                    break;

                case FILTER_TYPE.TRIM:
                    val = val.trim();
                    break;

                case FILTER_TYPE.NO_SPACE:
                    val = val.replace(/\s+/g, '');
                    break;

                case FILTER_TYPE.JUST_NUMBER_AND_LETTER:
                    val = val.replace(/[^a-zA-Z0-9]+/g, '');
                    break;

                case FILTER_TYPE.NO_CHINESE:
                    val = val.replace(/[\u4e00-\u9fa5]/g, '');
                    break;

                case FILTER_TYPE.ONLY_LETTER:
                    val = val.replace(/[^a-zA-Z]+/g, '');
                    break;

                case FILTER_TYPE.ONLY_CHINESE:
                    val = val.replace(/[^\u4e00-\u9fa5]+/g, '');
                    break;

                case FILTER_TYPE.ONLY_NUMBER:
                    val = val.replace(/\D+/g, '');
                    break;

                case FILTER_TYPE.NUMBER_AND_FLOAT:
                    val = val.replace(/[^\d.]/g, '');
                    let v = '';
                    let hasDot = false;
                    let firstNumber = '';
                    let dotIndex = -1;
                    let preDotZero = 0;
                    for (let j = 0; j < val.length; j++) {
                        if (v.length === 0 && val[j] === '.') continue;
                        //记录首位
                        if(j===0) firstNumber = val[j];
                        //处理‘0123’问题
                        if(firstNumber==='0'&&v.length===1&&val[j]!=='.') continue;
                        if (val[j] === '.' && v.indexOf('.') !== -1) continue;
                        if(val[j] === '.'){
                            dotIndex = j;
                            hasDot = true;
                        }
                        if (!hasDot&&val[j] === '0') {
                            preDotZero++;
                        }
                        if(preDotZero>1&&firstNumber==='0') continue;
                        if(hasDot&&j-2>dotIndex) continue;
                        v += val[j];
                    }
                    val = v;
                    break;

                case FILTER_TYPE.ID_CARD:
                    if (val.length > 0) {
                        const lastChar = val[val.length - 1];
                        val = val.replace(/\D+/g, '');
                        if (lastChar.toLowerCase() === 'x') {
                            val += 'X';
                        }
                    }
                    break;
                case FILTER_TYPE.TEL:
                    // 移除非数字字符（保留连字符）
                     val = val.replace(/[^\d-]/g, '');

                    // 处理座机号（以0开头）
                    if (val.startsWith('0')) {
                        // 只保留第一个连字符
                        const hyphenIndex = val.indexOf('-');
                        if (hyphenIndex !== -1) {
                            val = val.substring(0, hyphenIndex + 1) +
                                val.substring(hyphenIndex + 1).replace(/-/g, '');
                        }

                        // 自动添加连字符
                        if (!val.includes('-')) {

                            if (val.length>4&&AREA_CODE.CODE_LIST.includes(val.substring(0,4))) {
                                // 4位区号（如0379）
                                val = val.substring(0, 4) + '-' + val.substring(4);
                            } else if (val.length > 3&&AREA_CODE.CODE_LIST.includes(val.substring(0,3))) {
                                // 3位区号（如010）
                                val = val.substring(0, 3) + '-' + val.substring(3);
                            }
                        }
                    }
                    // 处理手机号（以1开头）
                    else if (val.startsWith('1')) {
                        // 移除非数字字符
                        val = val.replace(/\D/g, '');
                        // 限制长度为11位
                        if (val.length > 11) {
                            val = val.substring(0, 11);
                        }
                    }else{
                        val = val.replace(/\D/g, '');
                        if (val.length > 12) {
                            val = val.substring(0, 12);
                        }
                    }

                    break;
            }
        }
        return val
    },

    /**
     * 获取设备标识
     * @returns {string} 设备标识
     */
    detectBrowser() {

        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/MicroMessenger/i.test(userAgent)) {
            return "WeChat";
        } else if (/FBAN|FBAV/i.test(userAgent)) {
            return "Facebook";
        } else if (/Instagram/i.test(userAgent)) {
            return "Instagram";
        } else if (/Line/i.test(userAgent)) {
            return "Line";
        } else if (/Twitter/i.test(userAgent)) {
            return "Twitter";
        } else if (/Snapchat/i.test(userAgent)) {
            return "Snapchat";
        } else if (/Weibo/i.test(userAgent)) {
            return "Weibo";
        } else {
            return "Other";
        }
    },
    detectInWeiXinAppBrowser() {
        const ua = navigator.userAgent;
        console.log('agent',ua)
        // 检测微信内置浏览器
        const isWeChat = /WeChat/i.test(ua);



        return isWeChat;
    },
    detectDeviceIsMobileUA() {
        // 用户代理检测
        const ua = navigator.userAgent.toLowerCase();
        const isMobileUA = /mobi|android|iphone|ipad|ipod|windows phone|blackberry|opera mini/i.test(ua);

        // 媒体查询检测
        const isMobileMedia = window.matchMedia('(pointer: coarse) and (hover: none)').matches;

        // 触摸支持
        const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        // 屏幕尺寸
        const isSmallScreen = window.innerWidth < 768;

        // 综合判断
        return (isMobileUA && hasTouch) || isMobileMedia || (hasTouch && isSmallScreen);
    },
    /**
     * 判断值是否有效
     * @param value 值
     * @returns {boolean} 返回true为有效，false为无效
     */
    isEffective(value) {
        if (value === undefined || value === null) {
            return false;
        }
        if (typeof value === "string") {
            return value.replace(/\s+/, '').length > 0;
        }
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        if (typeof value === "object") {
            return Object.keys(value).length > 0;
        }
        if (typeof value === "number") {
            return !isNaN(value);
        }
        return true;
    },

    //滚动元素到可见位置
    smoothScrollToElement(element) {
        return new Promise((resolve) => {
            // 计算元素位置
            const elementRect = element.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.pageYOffset;
            const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);
            console.log(elementRect)
            // 使用requestAnimationFrame实现平滑滚动
            const duration = 600; // 动画持续时间（毫秒）
            const start = window.pageYOffset;
            const distance = middle - start;
            let startTime = null;

            function animation(currentTime) {
                if (startTime === null) startTime = currentTime;
                const timeElapsed = currentTime - startTime;
                const progress = Math.min(timeElapsed / duration, 1);

                // 使用缓动函数使滚动更平滑
                const ease = progress < 0.5 ?
                    2 * progress * progress :
                    -1 + (4 - 2 * progress) * progress;

                window.scrollTo(0, start + distance * ease);

                if (timeElapsed < duration) {
                    requestAnimationFrame(animation);
                } else {
                    resolve();
                }
            }

            requestAnimationFrame(animation);
        });
    },

    generateGithubImageUrl(key) {
        return 'https://cdn.jsdelivr.net/gh/CitizensLi/pics/' + key;
    },
}




